import { createReducer, createFeature, on } from "@ngrx/store";

import { stepAdapter, StepsState } from "./step.state";
import { stepActions } from "./step.actions";

const initialState: StepsState = stepAdapter.getInitialState({
  loading: false,
  error: null,
  pipelineCategories: {},
  pipelineSteps: {},
  categories: {},
  ids: [],
  entities: undefined
});

const reducer = createReducer(
  initialState,
  on(stepActions.findForSample, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(stepActions.findForSampleSuccess, (state, { steps, categories }) => {

    const newPipelineSteps = {
      ...state.pipelineSteps, ...steps.reduce((acc, step) => ({
        ...acc,
        [step.pipelineId]: [...(acc[step.pipelineId] || []), step.id],
      }), {})
    }

    const newCategories = {
      ...state.categories,
      ...categories,
    }

    const newPipelineCategories = {
      ...state.pipelineCategories,
      ...steps.reduce((acc, step) => ({
        ...acc,
        [step.pipelineId]: [...(acc[step.pipelineId] || []), ...step.categories],
      }), {})
    }

    return {
      ...stepAdapter.upsertMany(steps, state),
      pipelineSteps: newPipelineSteps,
      categories: newCategories,
      pipelineCategories: newPipelineCategories,
      loading: false,
      error: null,
    };
  }),
  on(stepActions.findForSampleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const stepFeature = createFeature({
  name: "protocolSteps",
  reducer,
});